import { useCallback, useState } from "react";
import { t } from "ttag";

import { useInvalidateCacheConfigsMutation } from "metabase/api";
import { ToolbarButton } from "metabase/common/components/ToolbarButton";
import { useDashboardContext } from "metabase/dashboard/context";
import { useRefreshDashboard } from "metabase/dashboard/hooks";

export const RefreshDashboardCacheButton = () => {
  const { dashboard, parameterQueryParams } = useDashboardContext();
  const { hardRefreshDashboardCardData } = useRefreshDashboard({
    dashboardId: dashboard?.id ?? null,
    parameterQueryParams,
  });
  const [invalidateCacheConfigs] = useInvalidateCacheConfigsMutation();
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleClick = useCallback(async () => {
    if (!dashboard?.id) {
      return;
    }

    setIsRefreshing(true);

    try {
      await invalidateCacheConfigs({
        include: "overrides",
        dashboard: dashboard.id,
      }).unwrap();
      await hardRefreshDashboardCardData();
    } finally {
      setIsRefreshing(false);
    }
  }, [dashboard?.id, hardRefreshDashboardCardData, invalidateCacheConfigs]);

  return (
    <ToolbarButton
      icon="refresh"
      aria-label={t`Clear cache and refresh`}
      tooltipLabel={t`Clear cache and refresh`}
      onClick={handleClick}
      loading={isRefreshing}
    />
  );
};
